module.exports = __webpack_public_path__ + "static/img/bg2-new.9e6b0674.png";